/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AbsenceDepartmentDutyRosterGetForExistingLeaveRequestParams,
  AbsenceDepartmentDutyRosterGetForNewLeaveRequestParams,
  AbsenceDepartmentDutyRosterMyWorkareaDutyRosterParams,
  AbsenceDepartmentDutyRosterResult,
  DepartmentDutyRosterResult
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getAbsenceDepartmentDutyRosterGetForNewLeaveRequestUrl = (params?: AbsenceDepartmentDutyRosterGetForNewLeaveRequestParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/AbsenceDepartmentDutyRoster/GetForNewLeaveRequest?${stringifiedParams}` : `/api/AbsenceDepartmentDutyRoster/GetForNewLeaveRequest`
}

export const absenceDepartmentDutyRosterGetForNewLeaveRequest = async (params?: AbsenceDepartmentDutyRosterGetForNewLeaveRequestParams, options?: RequestInit): Promise<AbsenceDepartmentDutyRosterResult> => {
  
  return customInstance<AbsenceDepartmentDutyRosterResult>(getAbsenceDepartmentDutyRosterGetForNewLeaveRequestUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAbsenceDepartmentDutyRosterGetForNewLeaveRequestQueryKey = (params?: AbsenceDepartmentDutyRosterGetForNewLeaveRequestParams,) => {
    return [
    `/api/AbsenceDepartmentDutyRoster/GetForNewLeaveRequest`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAbsenceDepartmentDutyRosterGetForNewLeaveRequestQueryOptions = <TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>, TError = ErrorType<unknown>>(params?: AbsenceDepartmentDutyRosterGetForNewLeaveRequestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAbsenceDepartmentDutyRosterGetForNewLeaveRequestQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>> = ({ signal }) => absenceDepartmentDutyRosterGetForNewLeaveRequest(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type AbsenceDepartmentDutyRosterGetForNewLeaveRequestQueryResult = NonNullable<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>>
export type AbsenceDepartmentDutyRosterGetForNewLeaveRequestQueryError = ErrorType<unknown>


export function useAbsenceDepartmentDutyRosterGetForNewLeaveRequest<TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>, TError = ErrorType<unknown>>(
 params: undefined |  AbsenceDepartmentDutyRosterGetForNewLeaveRequestParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>,
          TError,
          Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAbsenceDepartmentDutyRosterGetForNewLeaveRequest<TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: AbsenceDepartmentDutyRosterGetForNewLeaveRequestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>,
          TError,
          Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAbsenceDepartmentDutyRosterGetForNewLeaveRequest<TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: AbsenceDepartmentDutyRosterGetForNewLeaveRequestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useAbsenceDepartmentDutyRosterGetForNewLeaveRequest<TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: AbsenceDepartmentDutyRosterGetForNewLeaveRequestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getAbsenceDepartmentDutyRosterGetForNewLeaveRequestQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAbsenceDepartmentDutyRosterGetForNewLeaveRequestSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>, TError = ErrorType<unknown>>(params?: AbsenceDepartmentDutyRosterGetForNewLeaveRequestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAbsenceDepartmentDutyRosterGetForNewLeaveRequestQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>> = ({ signal }) => absenceDepartmentDutyRosterGetForNewLeaveRequest(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type AbsenceDepartmentDutyRosterGetForNewLeaveRequestSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>>
export type AbsenceDepartmentDutyRosterGetForNewLeaveRequestSuspenseQueryError = ErrorType<unknown>


export function useAbsenceDepartmentDutyRosterGetForNewLeaveRequestSuspense<TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>, TError = ErrorType<unknown>>(
 params: undefined |  AbsenceDepartmentDutyRosterGetForNewLeaveRequestParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAbsenceDepartmentDutyRosterGetForNewLeaveRequestSuspense<TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: AbsenceDepartmentDutyRosterGetForNewLeaveRequestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAbsenceDepartmentDutyRosterGetForNewLeaveRequestSuspense<TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: AbsenceDepartmentDutyRosterGetForNewLeaveRequestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useAbsenceDepartmentDutyRosterGetForNewLeaveRequestSuspense<TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: AbsenceDepartmentDutyRosterGetForNewLeaveRequestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForNewLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getAbsenceDepartmentDutyRosterGetForNewLeaveRequestSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAbsenceDepartmentDutyRosterGetForExistingLeaveRequestUrl = (params?: AbsenceDepartmentDutyRosterGetForExistingLeaveRequestParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/AbsenceDepartmentDutyRoster/GetForExistingLeaveRequest?${stringifiedParams}` : `/api/AbsenceDepartmentDutyRoster/GetForExistingLeaveRequest`
}

export const absenceDepartmentDutyRosterGetForExistingLeaveRequest = async (params?: AbsenceDepartmentDutyRosterGetForExistingLeaveRequestParams, options?: RequestInit): Promise<AbsenceDepartmentDutyRosterResult> => {
  
  return customInstance<AbsenceDepartmentDutyRosterResult>(getAbsenceDepartmentDutyRosterGetForExistingLeaveRequestUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAbsenceDepartmentDutyRosterGetForExistingLeaveRequestQueryKey = (params?: AbsenceDepartmentDutyRosterGetForExistingLeaveRequestParams,) => {
    return [
    `/api/AbsenceDepartmentDutyRoster/GetForExistingLeaveRequest`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAbsenceDepartmentDutyRosterGetForExistingLeaveRequestQueryOptions = <TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>, TError = ErrorType<unknown>>(params?: AbsenceDepartmentDutyRosterGetForExistingLeaveRequestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAbsenceDepartmentDutyRosterGetForExistingLeaveRequestQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>> = ({ signal }) => absenceDepartmentDutyRosterGetForExistingLeaveRequest(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type AbsenceDepartmentDutyRosterGetForExistingLeaveRequestQueryResult = NonNullable<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>>
export type AbsenceDepartmentDutyRosterGetForExistingLeaveRequestQueryError = ErrorType<unknown>


export function useAbsenceDepartmentDutyRosterGetForExistingLeaveRequest<TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>, TError = ErrorType<unknown>>(
 params: undefined |  AbsenceDepartmentDutyRosterGetForExistingLeaveRequestParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>,
          TError,
          Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAbsenceDepartmentDutyRosterGetForExistingLeaveRequest<TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: AbsenceDepartmentDutyRosterGetForExistingLeaveRequestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>,
          TError,
          Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAbsenceDepartmentDutyRosterGetForExistingLeaveRequest<TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: AbsenceDepartmentDutyRosterGetForExistingLeaveRequestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useAbsenceDepartmentDutyRosterGetForExistingLeaveRequest<TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: AbsenceDepartmentDutyRosterGetForExistingLeaveRequestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getAbsenceDepartmentDutyRosterGetForExistingLeaveRequestQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAbsenceDepartmentDutyRosterGetForExistingLeaveRequestSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>, TError = ErrorType<unknown>>(params?: AbsenceDepartmentDutyRosterGetForExistingLeaveRequestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAbsenceDepartmentDutyRosterGetForExistingLeaveRequestQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>> = ({ signal }) => absenceDepartmentDutyRosterGetForExistingLeaveRequest(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type AbsenceDepartmentDutyRosterGetForExistingLeaveRequestSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>>
export type AbsenceDepartmentDutyRosterGetForExistingLeaveRequestSuspenseQueryError = ErrorType<unknown>


export function useAbsenceDepartmentDutyRosterGetForExistingLeaveRequestSuspense<TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>, TError = ErrorType<unknown>>(
 params: undefined |  AbsenceDepartmentDutyRosterGetForExistingLeaveRequestParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAbsenceDepartmentDutyRosterGetForExistingLeaveRequestSuspense<TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: AbsenceDepartmentDutyRosterGetForExistingLeaveRequestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAbsenceDepartmentDutyRosterGetForExistingLeaveRequestSuspense<TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: AbsenceDepartmentDutyRosterGetForExistingLeaveRequestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useAbsenceDepartmentDutyRosterGetForExistingLeaveRequestSuspense<TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: AbsenceDepartmentDutyRosterGetForExistingLeaveRequestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterGetForExistingLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getAbsenceDepartmentDutyRosterGetForExistingLeaveRequestSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAbsenceDepartmentDutyRosterMyWorkareaDutyRosterUrl = (params?: AbsenceDepartmentDutyRosterMyWorkareaDutyRosterParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/AbsenceDepartmentDutyRoster/MyWorkareaDutyRoster?${stringifiedParams}` : `/api/AbsenceDepartmentDutyRoster/MyWorkareaDutyRoster`
}

export const absenceDepartmentDutyRosterMyWorkareaDutyRoster = async (params?: AbsenceDepartmentDutyRosterMyWorkareaDutyRosterParams, options?: RequestInit): Promise<DepartmentDutyRosterResult> => {
  
  return customInstance<DepartmentDutyRosterResult>(getAbsenceDepartmentDutyRosterMyWorkareaDutyRosterUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAbsenceDepartmentDutyRosterMyWorkareaDutyRosterQueryKey = (params?: AbsenceDepartmentDutyRosterMyWorkareaDutyRosterParams,) => {
    return [
    `/api/AbsenceDepartmentDutyRoster/MyWorkareaDutyRoster`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAbsenceDepartmentDutyRosterMyWorkareaDutyRosterQueryOptions = <TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>, TError = ErrorType<unknown>>(params?: AbsenceDepartmentDutyRosterMyWorkareaDutyRosterParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAbsenceDepartmentDutyRosterMyWorkareaDutyRosterQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>> = ({ signal }) => absenceDepartmentDutyRosterMyWorkareaDutyRoster(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type AbsenceDepartmentDutyRosterMyWorkareaDutyRosterQueryResult = NonNullable<Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>>
export type AbsenceDepartmentDutyRosterMyWorkareaDutyRosterQueryError = ErrorType<unknown>


export function useAbsenceDepartmentDutyRosterMyWorkareaDutyRoster<TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>, TError = ErrorType<unknown>>(
 params: undefined |  AbsenceDepartmentDutyRosterMyWorkareaDutyRosterParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>,
          TError,
          Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAbsenceDepartmentDutyRosterMyWorkareaDutyRoster<TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>, TError = ErrorType<unknown>>(
 params?: AbsenceDepartmentDutyRosterMyWorkareaDutyRosterParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>,
          TError,
          Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAbsenceDepartmentDutyRosterMyWorkareaDutyRoster<TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>, TError = ErrorType<unknown>>(
 params?: AbsenceDepartmentDutyRosterMyWorkareaDutyRosterParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useAbsenceDepartmentDutyRosterMyWorkareaDutyRoster<TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>, TError = ErrorType<unknown>>(
 params?: AbsenceDepartmentDutyRosterMyWorkareaDutyRosterParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getAbsenceDepartmentDutyRosterMyWorkareaDutyRosterQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAbsenceDepartmentDutyRosterMyWorkareaDutyRosterSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>, TError = ErrorType<unknown>>(params?: AbsenceDepartmentDutyRosterMyWorkareaDutyRosterParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAbsenceDepartmentDutyRosterMyWorkareaDutyRosterQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>> = ({ signal }) => absenceDepartmentDutyRosterMyWorkareaDutyRoster(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type AbsenceDepartmentDutyRosterMyWorkareaDutyRosterSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>>
export type AbsenceDepartmentDutyRosterMyWorkareaDutyRosterSuspenseQueryError = ErrorType<unknown>


export function useAbsenceDepartmentDutyRosterMyWorkareaDutyRosterSuspense<TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>, TError = ErrorType<unknown>>(
 params: undefined |  AbsenceDepartmentDutyRosterMyWorkareaDutyRosterParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAbsenceDepartmentDutyRosterMyWorkareaDutyRosterSuspense<TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>, TError = ErrorType<unknown>>(
 params?: AbsenceDepartmentDutyRosterMyWorkareaDutyRosterParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAbsenceDepartmentDutyRosterMyWorkareaDutyRosterSuspense<TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>, TError = ErrorType<unknown>>(
 params?: AbsenceDepartmentDutyRosterMyWorkareaDutyRosterParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useAbsenceDepartmentDutyRosterMyWorkareaDutyRosterSuspense<TData = Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>, TError = ErrorType<unknown>>(
 params?: AbsenceDepartmentDutyRosterMyWorkareaDutyRosterParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof absenceDepartmentDutyRosterMyWorkareaDutyRoster>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getAbsenceDepartmentDutyRosterMyWorkareaDutyRosterSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



